import { GetDemographicResponse, GetCoachDemographicResponse, GetMemberProfileResponse } from '../types/user';
import authorizedInstance from './authorizedInstance';

export const USER_BASE_API_ENDPOINT = '/api/v1/students';

export const getMemberProfile = (signal?: AbortSignal) => {
  return authorizedInstance.get<GetMemberProfileResponse>(`${USER_BASE_API_ENDPOINT}/member-profile`, { signal});
};

export const getMemberDemographics = (signal?: AbortSignal) => {
  return authorizedInstance.get<GetDemographicResponse>(`${USER_BASE_API_ENDPOINT}/member-demographics`, { signal});
};

export const getCoachDemographics = (signal?: AbortSignal) => {
  return authorizedInstance.get<GetCoachDemographicResponse>(`${USER_BASE_API_ENDPOINT}/coach-demographics`, { signal});
};